import { Component, HostListener } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { MessagingService } from '../../service/messaging.service';
import { SellerMessage } from '../../interface/seller-message.interface';
import { clientRequestLabel } from '../../utils/client-request.utils';

@Component({
  selector: 'app-notification-bell',
  standalone: true,
  imports: [AsyncPipe, RouterLink],
  templateUrl: './notification-bell.component.html',
  styleUrl: './notification-bell.component.scss',
})
export class NotificationBellComponent {
  isOpen = false;

  // The unread count comes from MessagingService's single poll (started by the
  // auth layout); a second faster poll here would duplicate the same request.
  readonly unreadCount$ = this.messaging.unreadCount$;
  readonly messages$    = this.messaging.messages$;
  readonly loading$     = this.messaging.loading$;

  constructor(
    private messaging: MessagingService,
    private router: Router,
  ) {}

  toggleDropdown(event: MouseEvent): void {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
    if (this.isOpen) this.messaging.loadMessages();
  }

  closeDropdown(): void {
    this.isOpen = false;
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    this.isOpen = false;
  }

  openMessage(msg: SellerMessage, event: MouseEvent): void {
    event.stopPropagation();
    this.messaging.markAsRead(msg.idTransactionHistory);
    this.isOpen = false;
    this.router.navigate(['/seller/messages'], {
      state: { selectedId: msg.idTransactionHistory },
    });
  }

  markAllRead(event: MouseEvent): void {
    event.stopPropagation();
    this.messaging.markAllAsRead();
  }

  label(msg: SellerMessage): string {
    return clientRequestLabel(msg.action, msg.platform) ?? msg.action;
  }

  badgeClass(action: string): string {
    const a = action.toLowerCase();
    // Failures
    if (a.includes('failed') || a.includes('fail') || a.includes('cancelad') || a.includes('riesgo')) return 'badge bg-danger';
    // Retries / warnings
    if (a.includes('retry') || a.includes('pending retry'))  return 'badge bg-warning text-dark';
    // Confirmations / payments received
    if (a.includes('confirmed') || a.includes('received') || a.includes('confirmad') || a.includes('pagad') || a.includes('activad')) return 'badge bg-success';
    // Terminal states
    if (a.includes('terminad') || a.includes('completad'))   return 'badge bg-secondary';
    // Invoice / upcoming events
    if (a.includes('invoice') || a.includes('próximo') || a.includes('proximo')) return 'badge bg-info text-dark';
    return 'badge bg-secondary';
  }

  timeAgo(dateStr: string): string {
    const now  = Date.now();
    const then = new Date(dateStr).getTime();
    const diff = Math.max(0, now - then);
    const mins  = Math.floor(diff / 60_000);
    const hours = Math.floor(diff / 3_600_000);
    const days  = Math.floor(diff / 86_400_000);
    if (mins  < 1)   return 'ahora';
    if (mins  < 60)  return `hace ${mins}m`;
    if (hours < 24)  return `hace ${hours}h`;
    if (days  < 7)   return `hace ${days}d`;
    return new Date(dateStr).toLocaleDateString('es', { month: 'short', day: 'numeric' });
  }

  trackById(_: number, msg: SellerMessage): number {
    return msg.idTransactionHistory;
  }
}
